import React from 'react';
import { Card, CardTitle } from '../../components/Card';
import { ODSComponent } from '../../components/ODS';
import { ODSLabel, ODSIndicator } from '../ODSSelect';

const ODSDashboardScreen = ({ dw, ods, onChange, onSelectAll, values }) => {
  const formatted = ods.map(odsItem => ({
    ...odsItem,
    indicators: odsItem.indicators.map(indicator => ({
      ...indicator,
      questions: indicator.questions.map(question => ({
        ...question,
        valuesCount: dw.filter(item => !['textarea', 'url'].includes(item.Tipo_Pergunta) && item.Pergunta_codigo === question.code).length
      })).filter(item => item.valuesCount > 0)
    })).filter(item => item.questions.length > 0)
  })).filter(item => item.indicators.length > 0)

  return <Card className="ods-screen" style={{ width: "100%" }}>
    <CardTitle title={`Relatório de impacto`.toLocaleUpperCase()}/>
    {formatted.map(odsItem => {
      return <div className='ods-item'>
        <ODSLabel onSelectAll={onSelectAll} {...odsItem} codes={odsItem.indicators.map(item => item.questions.map(item => item.code)).flat()} />
        {odsItem.indicators.map(indicator => <div className='ods-item ods-indicator wrap'>
          <ODSIndicator {...indicator} />
          {indicator.questions.map(question => <ODSIndicatorChart dw={dw.filter(item => !['textarea', 'url'].includes(item.Tipo_Pergunta) && item.Pergunta_codigo === question.code)} ods={odsItem.title} indicator={indicator.title} values={values} onChange={onChange} {...question} />)}
        </div>)}
      </div>
    })}
  </Card>
}

const ODSIndicatorChart = ({ dw, ods, indicator, values, onChange, code, title }) => {
  console.log({ dw });
  if (dw.length === 0) {
    return <></>
  }
  return <div className={`ods-item ods-indicator  ${dw[0].Tipo_Pergunta !== "file" ? 'chart' : ''}`}>
    <div className={`indicator-label-container chart`}>
      <div className='indicator-title'><b>{code}</b>{" - " + title}</div>
      <ODSComponent type={dw[0].Tipo_Pergunta} dw={dw} />
    </div>
  </div>     
} 

 
export default ODSDashboardScreen;